module.exports = __webpack_public_path__ + "img/Timeline_image_2021.94a0f577.png";